module.exports = __webpack_public_path__ + "img/open-close.4369e28e.jpeg";